<template>
  <div v-if="stats" class="ReservationQueryStats">
    <Set
      v-for="stat in statsDisplayed"
      :key="stat.name"
      v-bind="stat"
      size="lg">
      <Loader v-if="isFetching" />
      <template v-else>
        {{ stat.value }}
      </template>
    </Set>
  </div>
</template>

<script>
import Set from 'components/Set'
import { actions } from '@/views/utils'
import { buildServerQuery } from '@/views/utils/query'
import { currency } from '@/views/utils/filters'

export default {
  components: {
    Set,
  },
  props: {
    reservationQuery: Object,
  },
  data() {
    return {
      isFetching: false,
      stats: null,
    }
  },
  computed: {
    statsDisplayed() {
      return [
        {
          icon: 'sun',
          name: 'Užsakymai (aktyvūs)',
          value: this.stats.reservedCount,
        },
        {
          icon: 'bolt',
          name: 'Rezervuotas galingumas',
          value: `${this.stats.capacityReserved} kW`,
        },
        {
          icon: 'euro',
          name: 'Apmokėta',
          value: currency(this.stats.amountPaid),
        },
        {
          icon: 'bill',
          name: 'Laukiama apmokėjimų',
          value: currency(this.stats.amountPending),
        },
      ]
    },
  },
  methods: {
    fetchStats() {
      return this.$wrap(async () => {
        const query = buildServerQuery(this.reservationQuery)
        const stats = await this.FIND_RESERVATION_STAT(query)

        if (!stats || !stats.length) return

        this.stats = stats[0]
      }, 'isFetching')
    },
    ...actions('FIND_RESERVATION_STAT'),
  },
  watch: {
    reservationQuery: {
      immediate: true,
      handler: 'fetchStats',
    },
  },
}
</script>

<style lang="scss">
.ReservationQueryStats {
  display: grid;
  font-weight: $semibold;
  grid-template-columns: repeat(4, 1fr);
}
</style>
